"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const image_dimensions_1 = require("./image-dimensions");
function changeImageUrl({ replaceVariables, }) {
    return (state, actions, { tabName = state.ui.currentTabName, imageUrl }) => update => {
        const finalImageUrl = replaceVariables(imageUrl);
        actions.setters.setImageUrl({ tabName, imageUrl, finalImageUrl });
        setState(actions, tabName, true, undefined);
        image_dimensions_1.imageDimensions
            .getImageDimensions(finalImageUrl)
            .then(newImageDimensions => {
            const currentFinalImageUrl = update().tabs[tabName].finalImageUrl;
            if (currentFinalImageUrl !== finalImageUrl) {
                return;
            }
            setState(actions, tabName, false, newImageDimensions);
        })
            .catch(() => {
            const currentFinalImageUrl = update().tabs[tabName].finalImageUrl;
            if (currentFinalImageUrl !== finalImageUrl) {
                return;
            }
            setState(actions, tabName, false, undefined);
        });
    };
}
exports.changeImageUrl = changeImageUrl;
function setState(actions, tabName, loadingImage, newImageDimensions) {
    actions.setters.setLoadingImage({ tabName, loadingImage });
    actions.setters.setImageDimensions({ tabName, imageDimensions: newImageDimensions });
    actions.effects.recalculateWarnings({ tabName });
}
//# sourceMappingURL=change-image-url.js.map